import {GetCustomNoticePermissionsApiArg, useGetCustomNoticePermissionsQuery} from '@dms/api/core';

/**
 * Whether the server lets the current user add a custom notice to the given record.
 *
 * Fails closed: while the answer is in flight, when the request fails and for any payload that
 * is not literally `true`, adding stays denied. The policy lives here so the call sites cannot
 * drift apart.
 */
export function useCanAddCustomNotice(params: GetCustomNoticePermissionsApiArg) {
  const {data: permissions} = useGetCustomNoticePermissionsQuery(params);

  return {canAddCustomNotice: permissions?.canAdd === true};
}
